import React, { useContext, useEffect, useRef, useState } from "react";
import { Modal, TextareaAutosize, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useMutation } from "react-query";
import MessagePicker from "../picker";
import {
  setChannelMessageReply,
  setMessageRefresh,
} from "../../../../../redux/actions";
import { getEmojiByCode } from "../../util";
import fetcher from "../../../../../dataProvider";
import TagManager from "react-gtm-module";
import mixpanel from "mixpanel-browser";
import socketEvents from "../../../../../constant/socketEvents";
import { CommonContext } from "../../../../../../components/helper/commonContext";
import { Box } from "@mui/system";
import Popover from "@mui/material/Popover";
import PopupState, { bindTrigger, bindPopover } from "material-ui-popup-state";

const MessageTextBox = () => {
  const dispatch = useDispatch();
  const inputRef = useRef(null);
  const [message, setMessage] = useState("");
  const [cursorPosition, setCursorPosition] = useState(0);
  const [replyTo, setReplyTo] = useState(null);
  const [currentChannel, setCurrentChannel] = useState(null);
  const replyMessageState = useSelector((state) => state.community.replyTo);
  const userRole = localStorage.getItem("userRole");
  const [uploadFileview, setUploadFileview] = useState();
  const [preview, setPreview] = useState();
  const [successModal, setSuccessModal] = useState(false);
  const { userData } = useSelector((state) => state.user);
  const [previewImgVIdeoFile, setPreviewImgVIdeoFile] = useState();
  const [previewVideoFile, setPreviewVideoFile] = useState();
  var CommuntiyName;

  if (typeof window !== "undefined") {
    CommuntiyName = localStorage.getItem("CommuntiyName");
  }
  const currentChannelCommunityState = useSelector(
    (state) => state.community.currentChannel
  );
  const commonContext = useContext(CommonContext);
  const socket = commonContext.socket;

  const { mutate: postMessage } = useMutation((data) => {
    if (socket != null && socket.connected) {
      console.log(
        "socket Inside send Message\ndata : ",
        data,
        "\nsocket : ",
        socket.id,
        socket.connected
      );
      socket.emit(socketEvents.SEND_MESSAGE, data, (response) => {
        if (response.status == "success") {
          const tagManagerArgs = {
            dataLayer: {
              event: "MessageSent",
              songCategory: CommuntiyName,
              status: "Success",
            },
          };
          TagManager.dataLayer(tagManagerArgs);
          mixpanel.track(CommuntiyName);
          setMessage("");
          setCursorPosition(0);
          dispatch(setChannelMessageReply(null));
          // dispatch(setMessageRefresh(true));
          console.log("socket message sent and inside success");
        } else if (response.status == "failed") {
          const tagManagerArgs = {
            dataLayer: {
              event: "MessageSent",
              songCategory: CommuntiyName,
              status: "failed",
            },
          };
          TagManager.dataLayer(tagManagerArgs);
          console.log(response.error);
        }
        console.log("socket send message response : ", response);
      });
    }
    // Add the respective tag manager data
    else {
      console.log(
        "Socket send message failed ",
        socket == null ? socket : socket?.id,
        socket == null ? socket : socket.connected
      );
    }
  });
  useEffect(() => {
    if (currentChannelCommunityState) {
      setCurrentChannel(currentChannelCommunityState);
    }
  }, [currentChannelCommunityState]);
  useEffect(() => {
    setReplyTo(replyMessageState);
    setMessage("");
    if (replyMessageState) {
      inputRef.current.focus();
    }
  }, [replyMessageState]);
  const submitMessag = (data) => {
    postMessage(data);
  };

  const handleSend = (e) => {
    if (message.trim()?.length > 0) {
      let _data = {
        type: "text",
        text: message,
        channelId: currentChannel._id,
      };
      if (replyTo) {
        _data.parentId = replyTo._id;
      }
      submitMessag(_data);
    }
  };

  const onSelectEmoji = (e) => {
    let emoji = getEmojiByCode(e);
    let val = [
      message?.slice(0, cursorPosition),
      emoji,
      message?.slice(cursorPosition),
    ]?.join("");
    setCursorPosition(cursorPosition + emoji.toString().length);
    setMessage(val);
  };
  const onSelectGif = (e) => {
    let _data = {
      type: "gif",
      text: e,
      channelId: currentChannel._id,
    };
    if (replyTo) {
      _data.parentId = replyTo._id;
    }
    submitMessag(_data);
  };

  const [openCommunityuploadpopup, setOpenCommunityuploadpopup] =
    useState(false);
  const handleClose2 = () => {
    setOpenCommunityuploadpopup(false);
  };
  const handleOpen2 = () => {
    setOpenCommunityuploadpopup(true);
  };

  // image and video upload in community

  // convert image base64

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  // upload and preview API

  const { mutate: UploadImgandVideoFile } = useMutation(
    (data) => fetcher.post(`/v1/message/upload-attachment`, data),
    {
      onSuccess: (response) => {
        console.log("response  UploadImgandVideoFile file: \n", response);
        setUploadFileview(response?.data);
      },
      onError: (error) => {
        console.log("error: ", error);
        setUploadFileview("");
      },
    }
  );

  const handleVideoandImageSelected = async (e) => {
    console.log("Print value of Name:", e.target);
    var picture = e.target?.files[0];
    console.log("picture", picture);
    const imageconvertbase64 = await convertBase64(picture);
    // const objectUrl = URL.createObjectURL(picture);
    // setPreview(objectUrl);
    const formData = new FormData();
    formData.append("file", picture);
    UploadImgandVideoFile(formData);

    if (picture?.type?.substring(0, 5) === "image") {
      setPreviewImgVIdeoFile(imageconvertbase64);
    } else if (picture?.type?.includes("video")) {
      setPreviewVideoFile(picture);
    }

    console.log("previewVideoFile", previewVideoFile);

    setOpenCommunityuploadpopup(false);
  };

  const { mutate: messageUploadFile } = useMutation(
    (data) => fetcher.post(`/v1/message`, data),
    {
      onSuccess: (response) => {
        setUploadFileview();
        setMessage("");
        console.log("response  messageUploadFile file: \n", response);
      },
      onError: (error) => {
        console.log("error: ", error);
      },
    }
  );

  const handleEnter = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      let data = {
        type: "text",
        text: message,
        channelId: currentChannelCommunityState?._id,
      };
      setMessage(e.target.value);
      setCursorPosition(e.target.selectionEnd);
      e.preventDefault();
      if (uploadFileview) {
        // Api call of create message, to upload file.
        console.log("uploadFileview", uploadFileview?.[0]);
        data.attachments = uploadFileview;
        messageUploadFile(data);
      } else {
        // Send the messsage through socket, as upload file is not there in sockets
        handleSend();
      }
    }
  };

  return (
    <Box className="uploader">
      {currentChannelCommunityState?.type == "stage" ? (
        <div className="stage_messagetext_box_container">
          <TextareaAutosize
            id="msg_textarea"
            maxRows={7}
            placeholder={"Type a comment"}
            onChange={(e) => {
              setMessage(e.target.value);
              setCursorPosition(e.target.selectionEnd);
            }}
            onMouseUp={(e) => setCursorPosition(e.target.selectionEnd)}
            onKeyPress={handleEnter}
            value={message}
            ref={inputRef}
            // disabled={
            //   userRole != "admin" &&
            //   (currentChannel?.private || currentChannel?.type == "stage")
            // }
          />
          <div className="stage_message_action_btn">
            <MessagePicker
              onSelectEmoji={onSelectEmoji}
              onSelectGif={onSelectGif}
              isEmoji={true}
              isGif={true}
              disabled={
                userData?.role != "admin" &&
                (currentChannel?.private || currentChannel?.type == "stage")
              }
            />
            <button
              type="button"
              className="send-btn hint hint-top"
              aria-label="Send"
              // disabled={
              //   userRole != "admin" &&
              //   (currentChannel?.private || currentChannel?.type == "stage")
              // }
              onClick={handleSend}
            >
              <img src="/images/send.svg" />
            </button>
          </div>
        </div>
      ) : (
        <div
          className={`message_input message_input_box ${
            replyTo ? "reply" : ""
          }`}
        >
          {replyTo && (
            <div className="reply-box">
              <p>
                Reply To <b>{replyTo?.user?.name}</b>
              </p>
              <button
                onClick={() => {
                  dispatch(setChannelMessageReply(null));
                }}
              >
                X
              </button>
            </div>
          )}
          {uploadFileview && (
            <Box className="preview-box">
              <Box style={{ position: "relative", display: "inline-block" }}>
                {previewImgVIdeoFile ? (
                  <img src={previewImgVIdeoFile} />
                ) : (
                  <video
                    width="150"
                    height="100"
                    controls
                    style={{ transform: "none" }}
                  >
                    <source
                      src={previewImgVIdeoFile}
                      type={previewVideoFile?.type}
                    />
                  </video>
                )}

                <img
                  src="/images/community/deleteicon.svg"
                  onClick={() => setUploadFileview()}
                  title="Remove Attachement"
                />
              </Box>
            </Box>
          )}

          <TextareaAutosize
            id="msg_textarea"
            maxRows={7}
            placeholder={
              userData?.role != "admin" &&
              (currentChannel?.private ||
                currentChannel?.name == "Announcements")
                ? "You do not have permission to send messages in read only channel"
                : "Type a comment"
            }
            onChange={(e) => {
              setMessage(e.target.value);
              setCursorPosition(e.target.selectionEnd);
            }}
            onMouseUp={(e) => setCursorPosition(e.target.selectionEnd)}
            onKeyPress={handleEnter}
            value={message}
            ref={inputRef}
            disabled={
              userData?.role != "admin" &&
              (currentChannel?.private ||
                currentChannel?.name == "Announcements")
            }
          />
          {userData?.role == "admin" && (
            <Box className="upload-icon">
              <PopupState variant="popover">
                {(popupState) => (
                  <>
                    <Box {...bindTrigger(popupState)}>
                      <button onClick={handleOpen2} type="button">
                        <img src="/images/community/uploadicon.svg" />
                      </button>
                    </Box>
                    <Popover
                      {...bindPopover(popupState)}
                      anchorOrigin={{
                        vertical: "top",
                        horizontal: "left",
                      }}
                      transformOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                      }}
                      open={openCommunityuploadpopup}
                      onClose={handleClose2}
                      id="upload-attachment"
                    >
                      <input
                        type="file"
                        onChange={(e) => handleVideoandImageSelected(e)}
                        id="choose-file"
                        className="d-none"
                      />
                      <label htmlFor="choose-file" className="upload-container">
                        <img
                          src="/images/community/selectfileIcon.svg"
                          width="24px"
                        />
                        <div>
                          <h5>Upload a file</h5>
                        </div>
                      </label>
                    </Popover>
                  </>
                )}
              </PopupState>
            </Box>
          )}

          <div className="action_btn">
            <MessagePicker
              onSelectEmoji={onSelectEmoji}
              onSelectGif={onSelectGif}
              isEmoji={true}
              isGif={true}
              disabled={
                userData?.role != "admin" &&
                (currentChannel?.private ||
                  currentChannel?.name == "Announcements")
              }
            />
            <button
              type="button"
              className="send-btn hint hint-top"
              aria-label="Send"
              disabled={
                userData?.role != "admin" &&
                (currentChannel?.private ||
                  currentChannel?.name == "Announcements")
              }
              onClick={handleSend}
            >
              {/* <img src="/images/community/create-thread.svg" width="20" style={{marginRight:"5px"}} height="20" /> */}
              <img src="/images/send.svg" />
            </button>
          </div>
          <Modal
            open={successModal}
            onClose={() => {
              setSuccessModal(false);
            }}
          >
            <Box className="errorfile-message">
              <Box className="alert-Message-invalidfile">
                <Box
                  component="img"
                  src="/images/community/erroricon.svg"
                  width="20px"
                />
                <Typography variant="span" className="invalidfile-content">
                  Invalid file format, please upload image file in (jpeg,png).
                </Typography>
              </Box>

              <Box
                onClick={() => {
                  setSuccessModal(false);
                }}
                component="img"
                src="/images/alert/close-icon.svg"
                style={{ cursor: "pointer" }}
                width="20"
              />
            </Box>
          </Modal>
        </div>
      )}
    </Box>
  );
};

export default MessageTextBox;
